import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { MAX_RECOMMEND_RANKING } from "../../../constants/Constants";
import StarBorder from "material-ui-icons/StarBorder";
import Star from "material-ui-icons/Star";
import StarHalf from "material-ui-icons/StarHalf";

const styles = () => ({
  label: {
    paddingLeft: "16px",
    fontSize: "13px",
    fontWeight: "bold",
  },

  toggle: {
    margin: 0,
  },
});

class RecommendRanking extends React.Component {
  render() {
    const { recommendRank } = this.props;

    if (!recommendRank) {
      return null;
    }

    // それぞれの星の数を計算
    const fullStarCount = Math.floor(recommendRank);
    const halfStarCount = (recommendRank - fullStarCount > 0) ? 1 : 0;

    const stars = [];
    for (let i = 1; i <= MAX_RECOMMEND_RANKING; i++) {
      let Tag;
      if (i <= fullStarCount) {
        Tag = Star;
      } else if (i === fullStarCount + halfStarCount) {
        Tag = StarHalf;
      } else if (i > fullStarCount + halfStarCount) {
        Tag = StarBorder;
      }
      stars.push(<Tag style={{ color: '#FFC62B', width: this.props.size, height: this.props.size }} key={i} />);
    }

    return <div style={this.props.style}>{stars}</div>;
  }
}

RecommendRanking.propTypes = {
  style: PropTypes.object,
  recommendRank: PropTypes.number.isRequired,
  size: PropTypes.number,
};

RecommendRanking.defaultProps = {
  size: 16,
};

export default withStyles(styles)(RecommendRanking);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/parts/RecommendRanking.jsx